import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useSideMenuAdminMonitoringStyles = makeStyles((theme: Theme) => ({
    warningIconSideMenu: {
        color: "orange",
        fontSize: 20,
        marginRight: theme.spacing(1),
    },
    errorIconSideMenu: {
        color: "red",
        fontSize: 20,
        marginRight: theme.spacing(1),
    },
    menuContent: {
        maxWidth: 378,
    },
}));
